import * as yup from 'yup';

export const PasswordFormValidationSchema = yup.object({
  username: yup
    .string()
    .email('Work email must be a valid email')
    .required('Work email is a required field'),
  password: yup
    .string()
    .default('')
    .when('showPasswordInput', {
      is: true,
      then: yup.string().required('Password is a required field')
    }),
  showPasswordInput: yup.boolean(),
  showEmailInput: yup.boolean()
});

export type PasswordFormValues = yup.InferType<
  typeof PasswordFormValidationSchema
>;
